// ==============================|| OVERRIDES - TABLE BODY ||============================== //

export default function TableBody(theme) {
  return {
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.background.paper,
          '& .MuiTableRow-root:hover': { backgroundColor: theme.vars.palette.primary.lighter }
        }
      }
    }
  };
}
